// extracted by mini-css-extract-plugin
var _1 = "styles-module__favorite___H4gJe";
var _2 = "styles-module__header___S68w3";
var _3 = "styles-module__icon___QilQJ";
var _4 = "styles-module__icon-text___QvOBY";
var _5 = "styles-module__noResults___toAvA";
var _6 = "styles-module__recordings___WUcse";
var _7 = "styles-module__searching___bdp6I";
var _8 = "styles-module__trailpost___d_geb";
export { _1 as "favorite", _2 as "header", _3 as "icon", _4 as "iconText", _5 as "noResults", _6 as "recordings", _7 as "searching", _8 as "trailpost" }
